import type { RouteLeafConfig } from '@/types/utils';
import { WardrobeRouteSegments } from '@/shared/routePaths';
import {
  WardrobeFavoritesPage,
  WardrobeItemEditPage,
  WardrobeItemsReviewPage,
  WardrobeMyItemsAddPage,
  WardrobeMyItemsPage,
  WardrobeOutfitsPage,
} from './pages';

/**
 * Child routes under `/wardrobe` (paths relative to parent).
 * Order: static segments before parametric `my-items` so `review` / `edit` match first.
 */
export const wardrobeChildRouteConfig: readonly RouteLeafConfig[] = [
  {
    path: WardrobeRouteSegments.favorites,
    Component: WardrobeFavoritesPage,
  },
  {
    path: WardrobeRouteSegments.myItemsAdd,
    Component: WardrobeMyItemsAddPage,
  },
  {
    path: WardrobeRouteSegments.myItemsReviewEdit,
    Component: WardrobeItemEditPage,
  },
  {
    path: WardrobeRouteSegments.myItemsReview,
    Component: WardrobeItemsReviewPage,
  },
  {
    path: WardrobeRouteSegments.myItemsEdit,
    Component: WardrobeItemEditPage,
  },
  {
    path: WardrobeRouteSegments.myItems,
    Component: WardrobeMyItemsPage,
  },
  {
    path: WardrobeRouteSegments.outfits,
    Component: WardrobeOutfitsPage,
  },
];
